import {
  Connections,
  FormikFormConnectionKey,
} from '@mss/mss-component-library';

export const resultPath: Record<keyof Connections, FormikFormConnectionKey> = {
  direct: 'test_direct',
  ssh: 'test_ssh',
  telnet: 'test_telnet',
  snmp: 'test_snmp',
};
